import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export interface UploadedNotice {
  applyTo: string;
  company: string | null;
  pickedFilename: string;
  storedFilename: string;
}

interface Props {
  notice: UploadedNotice | null;
  onDismiss: () => void;
}

/**
 * Acknowledgement shown after an upload, before the row leaves the list. The rename is surfaced
 * deliberately: the server stores every upload as Invoice-<apply_to>.pdf, so the name the admin
 * picked is not the name that ends up attached to collection and statement emails.
 */
const UploadedInvoiceDialog: React.FC<Props> = ({ notice, onDismiss }) => (
  <Dialog open={notice !== null} onClose={onDismiss} maxWidth="sm" fullWidth>
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box>Invoice PDF uploaded</Box>
      <IconButton onClick={onDismiss} size="small" aria-label="Close">
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      {notice && (
        <>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            <strong>{notice.pickedFilename}</strong> was renamed to <strong>{notice.storedFilename}</strong> and
            attached to invoice #{notice.applyTo}{notice.company ? ` for ${notice.company}` : ''}.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Invoice PDFs are always stored as {'Invoice-<invoice number>.pdf'}. This invoice will now be removed from
            the Missing Invoices list.
          </Typography>
        </>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onDismiss} variant="contained">
        OK
      </Button>
    </DialogActions>
  </Dialog>
);

export default UploadedInvoiceDialog;
